import { render, staticRenderFns } from "./agreements.vue?vue&type=template&id=4bf9bbdc&scoped=true"
import script from "./agreements.vue?vue&type=script&lang=js"
export * from "./agreements.vue?vue&type=script&lang=js"
import style0 from "./agreements.vue?vue&type=style&index=0&id=4bf9bbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9bbdc",
  null
  
)

export default component.exports